import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel, Grid, SvgIcon, Menu } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast from "react-hot-toast";
import { Link } from "@material-ui/core";
import { Button } from "@material-ui/core";
import {
  getDateTime,
  editTicketPath,
  searchFilter,
  handleSort,
  investmentDetailsPath,
} from "../utils/varialbles";
import http from "../services/httpService";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import SearchBar from "material-ui-search-bar";
import Filter from "../components/filerComponent";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
import staticFiles from "../services/staticApi";
import ReactReadMoreReadLess from "react-read-more-read-less";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const columns = [
  { label: "Date & Time", id: "createddt", format: "Date" },
  { label: "Employee First Name", id: "emp__empfname" },
  { label: "Check-in Status", id: "checkin_status" },
  // { label: "Comments", id: "comments", minWidth: 200, type: "comments" },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

function CheckStatus(props) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const [anchorEl, setAnchorEl] = React.useState(null);
  // (Boolean(anchorEl));
  // const isMenuOpen = Boolean(anchorEl);
  const location = useLocation();
  const myparam = location.state;
  const isMenuOpen = anchorEl;
  const form = {
    issue_type: [],
    ticket_created_at: "",
    ticket_created_at__condition: "lte",
    reporter: [],
    assigned: [],
    severity: [],
    status: "",
  };
  const [formObject, setFormObject] = useState(form);
  const clearFilter = () => {
    setFormObject(form);
    setRows(orignalRows);
    localStorage.removeItem("ticketFilter");
  };
  const applyFilter = (e) => {
    localStorage.setItem("ticketFilter", JSON.stringify(formObject));
    setAnchorEl(null);
    // ('am filter', e, filter);
    let tempObject = { ...formObject };
    let tempORows = [...orignalRows];
    let filter = filterData(tempObject, tempORows, columns);
    setRows(filter);
    setPage(0);
  };

  const openFilter = (e) => {
    // let currentTarget = e.currentTarget;
    // setAnchorEl(currentTarget);
    setAnchorEl(true);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const closeFilter = () => {
    setAnchorEl(null);
  };
  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const viewDetails = (object) => {
    object.page = page;
    history.push({
      pathname: editTicketPath,
      state: object,
    });
  };
  const gotoProspect = () => {
    history.push({
      // pathname: prospectPath,
      pathname: investmentDetailsPath,
      state: myparam,
    });
  };

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("selectedfiltersdata");
    // localStorage.removeItem("selectedinvestorfiltersdata");

    prospect_reassign_flowList();
    // (page);
  }, []);
  // console.log(location.state);
  const prospect_reassign_flowList = () => {
    toast.loading("Please wait...");

    http
      // .get("/ticketlist")
      .get("/checkin_status_reassign_flow/" + location.state.customer_id)

      .then((response) => {
        toast.dismiss();
        if (response && response.data && response.data.data.length > 0) {
          // console.log(response.data.data);
          setOriginalRows(response.data.data);
          setRows(response.data.data);
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const checkinStatusMapping = (statusValue) => {
    const statusMap = {
      S: "Satisfied",
      U: "Unsatisfied",
      D: "DNA",
    };

    return statusMap[statusValue] || "N/A";
  };

  // console.log(rows);

  return (
    <Paper className={classes.root}>
      <Button
        variant="outlined"
        color="default"
        startIcon={<ArrowBackIosIcon />}
        onClick={gotoProspect}
      >
        Back
      </Button>
      <Grid container style={{ justifyContent: "space-between", margin: 10 }}>
        <Grid item xs={3}>
          <SearchBar
            value={searched}
            onChange={(searchVal) => requestSearch(searchVal)}
            onCancelSearch={() => cancelSearch()}
            style={{ height: "unset", padding: "5px", marginTop: 5 }}
          />
        </Grid>
        <Grid container xs={5} style={{ flexWrap: "nowrap" }}>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 1500]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          {/* <div
                        style={{ display: "flex", marginLeft: 10, cursor: "pointer" }}
                        onClick={openFilter}
                    >
                        <p>Filter</p>
                        <SvgIcon
                            style={{ cursor: "pointer", marginTop: 15, marginLeft: 5 }}
                            title={"filter"}
                        >
                            <FilterLogo />
                        </SvgIcon>
                    </div> */}
          <Menu
            anchorEl={anchorEl}
            id={"Filtermenu"}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}
            getContentAnchorEl={null}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <Filter
              columns={columns}
              applyFilter={applyFilter}
              orignalRows={orignalRows}
              handleChange={handleChange}
              formObject={formObject}
              clearFilter={clearFilter}
              closeFilter={closeFilter}
            />
          </Menu>
        </Grid>
      </Grid>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  className="prospect_table"
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : "asc"}
                    onClick={(e) =>
                      handleRequestSort(e, column.id, column.format)
                    }
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length !== 0 ? (
              <>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index + "a"}
                        className="prospecttable"
                      >
                        {columns.map((column, index) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={index + column.id}
                              align={column.align}
                            >
                              {column.id === "checkin_status"
                                ? checkinStatusMapping(value)
                                : column.format === "date"
                                ? getDateTime(value)
                                : value
                                ? value
                                : "N/A"}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </>
            ) : (
              <TableCell
                colspan="7"
                style={{ "text-align": "center", margin: "10px 0px" }}
              >
                Records Not Available
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
export default CheckStatus;
